import DOMPurify from "dompurify";
import { Product } from "../../types/Product";
import { Icon } from "../liquid/LiquidPrimitives";

interface ProductDescriptionProps {
    product: Product;
}

export default function ProductDescription({ product }: ProductDescriptionProps) {
    const sanitizedHtml = DOMPurify.sanitize(
        product.descripcionLarga || product.descripcionCorta || "",
    );

    return (
        <div className="lg-strong" style={{ padding: "22px 24px", borderRadius: 22 }}>
            <details open>
                <summary
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                        listStyle: "none",
                    }}
                >
                    <span style={{ fontSize: 14, fontWeight: 500, letterSpacing: "-0.01em" }}>
                        Detalles del producto
                    </span>
                    <Icon.plus />
                </summary>
                <div
                    style={{
                        marginTop: 14,
                        fontSize: 13,
                        color: "var(--ink-700)",
                        lineHeight: 1.6,
                    }}
                    dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
                />
            </details>
        </div>
    );
}
